import { atom } from 'recoil'

export const cookiesState = atom({
    key: 'cookies',
    default: 0, 
  });